import { useState, useEffect } from 'react';
import { ChateauFilterService, FilterCriteria } from '@/services/chateauFilterService';

interface UseChateauFilteringProps {
  chateaux: any[];
}

export const useChateauFiltering = ({ chateaux }: UseChateauFilteringProps) => {
  const [selectedSpace, setSelectedSpace] = useState<string>("");
  const [selectedBudget, setSelectedBudget] = useState<string>("");
  const [recommendations, setRecommendations] = useState<any[]>([]);

  const updateRecommendations = () => {
    const criteria: FilterCriteria = {
      space: selectedSpace,
      budget: selectedBudget
    };

    const filtered = ChateauFilterService.filterChateaux(chateaux, criteria);
    setRecommendations(filtered);
  };

  // Auto-update recommendations when criteria change
  useEffect(() => {
    updateRecommendations();
  }, [selectedSpace, selectedBudget, chateaux]);

  const resetFilters = () => {
    setSelectedSpace("");
    setSelectedBudget("");
    setRecommendations([]);
  };

  return {
    selectedSpace,
    setSelectedSpace,
    selectedBudget,
    setSelectedBudget,
    recommendations,
    resetFilters,
    hasValidCriteria: Boolean(selectedSpace && selectedBudget),
    spaceOptions: ChateauFilterService.getSpaceOptions(),
    budgetOptions: ChateauFilterService.getBudgetOptions()
  };
};